import { Expose } from "class-transformer";

export class AdvertisingTypeModel {
    constructor() {
        this.text = "";
        this.value = 0;
    }

    @Expose({ name: "adName" })
    text: string;

    @Expose({ name: "advertisingId" })
    value: number;
}
